// eslint-disable-next-line import/no-anonymous-default-export
export default {
  translation: {
    yes: "Oui",
    no: "Non",
    cancel: "Annuler",
    showingRows: "Affichage {{shown}} / {{total}}",
    close: "Fermer",
    caution: "Attention",
    actionsForSelection: "Actions sur la sélection",
    exit: "Terminer",
    notFound: {
      resultsNotFound: "Non trouvé...",
    },
    //User Access
    ua: {
      loading: "Chargement...",
      project_not_loaded: "Le projet n'a pas pu être chargé",
      access_denied: "Accès refusé",
      user_access: "Partage d'utilisateur",
      email: "E-Mail",
      roles: "Rôles",
      email_address: "E-Mail-Adresse",
      add_user: "Ajouter un utilisateur",
      import_user: "Importer un utilisateur à partir d'un fichier",
      select_none: "Aucun\nsélectionner",
      select_all: "Tous\nsélectionner",
      remove_all: "Tous\nretirer",
      remove_selected: "Sélectionnés\nretirer",
      export_all: "Tous\nexporter",
      export_selected: "Sélectionnés\nexporter",
      remove_user: "Retirer un utilisateur",
      copy_id: "Copier l'ID utilisateur",
      id_copied: "ID utilisateur copié",
      process_access: "Partage de processus",
      process_filter: "Filtre de processus",
      remove_process_filter: "Retirer le filtre de processus",
      sections_and_processes: "Sections et processus terminés",
      external: "Externe",
      internal: "Interne",
      collapse_expand_processes: "Processus de cette section {{collapse}}",
      collapse: "réduire",
      expand: "développer",
      alerts: {
        wrong_filetype: "Le fichier '{{file}}' ne peut pas être traité car il ne s'agit pas d'un fichier texte.",
        user_not_added: "Les utilisateurs suivants n'ont pas pu être ajoutés",
        user_in_project: "L'utilisateur est déjà dans ce projet",
        user_added: "Les utilisateurs suivants ont été ajoutés avec succès",
        user_not_removed: "Les utilisateurs suivants n'ont pas pu être retirés",
        remove_all_users: "Voulez-vous vraiment retirer tous les utilisateurs ?",
        remove_selected_users: "Voulez-vous vraiment retirer tous les utilisateurs sélectionnés ?",
        external_not_switched: "Le partage pour les employés externes n'a pas pu être modifié",
        internal_not_switched: "Le partage pour les employés internes n'a pas pu être modifié",
        process_not_switched: "Le partage de processus n'a pas pu être modifié",
      },
    },
    customerSettings: {
      title: "Paramètres",
      geoServices: {
        title: "Services Géo Externes",
        add: "Ajouter",
        empty: "Aucun service géo externe disponible.",
        createTitle: "Créer un Service Géo",
        editTitle: "Modifier le Service Géo",
        deleteTitle: "Supprimer le Service Géo",
        deleteConfirm: "Êtes-vous sûr de vouloir supprimer ce service géo ?",
        nameLabel: "Nom",
        urlLabel: "URL",
        save: "Enregistrer",
        cancel: "Annuler",
        delete: "Supprimer",
        validationError: "Le nom et l'URL sont obligatoires.",
        configValidationError: "Le champ \"{{field}}\" est obligatoire.",
        typeLabel: "Type",
        configSection: "Configuration",
        getCapabilities: "Obtenir les capacités",
        capabilitiesHint: "Entrez l'URL et cliquez sur 'Obtenir les capacités' pour charger les options de configuration.",
        capabilitiesSuccess: "Connexion réussie. Les options de configuration ont été chargées.",
        capsFailed: "GetCapabilities a échoué",
        capsCorsFailed: "Connexion échouée. Le serveur n'autorise peut-être pas les requêtes cross-origin (CORS).",
        config: {
          layers: "Couches",
          layer: "Couche",
          format: "Format",
          version: "Version",
          projection: "Projection",
          matrixSet: "MatrixSet",
          tmsY: "Axe Y TMS (Y=0 en bas, inversé)",
        },
      },
    },
    leftNav: {
      dashboard: "Tous les projets",
      sbb: "Clearance Inspector",
      betaViewer: "MapLibre",
      uploader: "Uploader",
      projects: "Projets",
      processes: "Processus",
      tools: "Outils",
      management: "Gestion",
      userManagement: "Utilisateurs",
      language: "Langue",
      help: "Aide",
      faq: "FAQ",
      logout: "Déconnexion",
      account: "Compte",
      userManual: "Manuel de l'utilisateur",
      support: "Support",
      credit: "Contrôle des coûts",
      customerSettings: "Paramètres",
    },
    accountSettings: {
      title: "Paramètres utilisateur",
      userName: "Nom d'utilisateur",
      role: "Rôle",
      communicationEmail: "Adresse e-mail de contact",
      change: "Modifier",
      save: "Enregistrer",
      cancel: "Annuler",
      close: "Fermer",
      invalidEmail: "Veuillez saisir une adresse e-mail valide",
      emailUpdated: "Adresse e-mail de contact mise à jour",
      emailUpdateFailed: "L'adresse e-mail de contact n'a pas pu être mise à jour",
      emailNotConfirmed: "Cette adresse e-mail n'a pas encore été confirmée.",
      newsletter: "Recevoir la newsletter/les mises à jour",
      newsletterUpdated: "Préférence de newsletter mise à jour",
      newsletterUpdateFailed: "La préférence de newsletter n'a pas pu être mise à jour",
      deleteAccount: "Supprimer le compte",
      deleteConfirm: "Souhaitez-vous demander la suppression de votre compte ? Notre équipe de support vous contactera.",
      deleteRequested: "Demande de suppression envoyée",
      deleteFailed: "La demande de suppression n'a pas pu être envoyée",
    },
    v: {
      max_active_geo_layers: "Un maximum de {{count}} couches GEO/Objets peut être actif en même temps.",
      gnd_profile_requires_layer: "Un profil nécessite une couche GND visible dans la vue 3D.",
      gnd_profile_no_visible_line: "Aucune ligne GND sélectionnable n’est visible dans la vue 3D actuelle.",
      gnd_profile_failed: "Le profil n’a pas pu être créé.",
      axis_measurement_requires_km_layer: "Cette mesure nécessite une couche kilométrique (GND) visible dans la vue 3D.",
      axis_measurement_requires_track_layer: "Cette mesure nécessite une couche d’axes de voie (GND) visible dans la vue 3D.",
      axis_measurement_no_visible_axis: "Aucun axe sélectionnable n’est visible dans la vue 3D actuelle.",
      axis_measurement_no_km_data: "L’axe sélectionné ne contient pas de données kilométriques.",
      axis_measurement_km_data_problem: "Problème avec les données du réseau ferré.",
      axis_measurement_failed: "La mesure d’axe n’a pas pu être effectuée.",
      windows: {
        catalog: "Catalogue",
        measurements: "Mesures",
        layer_menu: "Menu des calques",
        gis_object: "Objet SIG",
      },
      axis_measurement_names: {
        KILOMETRIERUNG: "Kilométrage",
        KILOMETRIERUNG_DISTANCE: "Axe kilométrique",
        GLEISACHSE_DISTANCE: "Axe de voie",
        GLEISACHSE_GAP: "Distance à l’axe",
      },
      measurement_details: {
        results: "Résultats",
        resample_elevation: "Reprendre les altitudes du nuage de points",
        total_length: "Longueur totale",
        projected_length: "Longueur projetée",
        vertical_extent: "Étendue verticale",
        line_details: "Détails ({{segments}} segments, {{vertices}} sommets)",
        segments: "Segments ({{count}})",
        segment: "Seg. {{n}}",
        slope: "Pente",
        vertices: "Sommets ({{count}})",
        add_point: "Ajouter un point",
        area_2d: "Surface (2D)",
        perimeter: "Périmètre",
        polygon_details: "Détails ({{edges}} arêtes)",
        edges: "Arêtes ({{count}})",
        edge: "Arête {{n}}",
        fill: "Remblai",
        cut: "Déblai",
        total_volume: "Volume total",
        height_difference: "Différence de hauteur (ΔZ)",
        horizontal_distance: "Distance horizontale",
        distance_3d: "Distance 3D",
        base_point: "P1 (base)",
        compare_point: "P2 (comparaison)",
        volume_options: "Options de calcul (volume)",
        flatten: "Aplanir sur un plan",
        plane_height: "Hauteur du plan",
        undo_flatten: "Annuler (rétablir les hauteurs d’origine)",
        max_height: "différence de hauteur maximale",
        max_height_hint: "Distance maximale d’un point au plan de référence pour être compté",
        name: "Nom",
        description: "Description",
        type_point: "Point",
        type_line: "Ligne",
        type_polygon: "Polygone",
        type_volume: "Volume",
        type_height_difference: "Différence de hauteur",
        labels: "Étiquettes",
        mirror: "Refléter dans l’autre vue",
        finish_edit: "Terminer la modification",
        edit: "Modifier",
        recalc_volume: "Recalculer le volume",
        open_profile: "Ouvrir le profil",
        zoom_to: "Zoomer sur",
      },
      axis_details: {
        km: "Point kilométrique",
        km_data: "Données du réseau ferré",
        side: "Côté",
        distance_to_axis: "Distance à l’axe",
        series: "Série",
        role: "Type",
        calibration: "Calibrage",
        calibration_offset: "Décalage calibré",
        distance_along_axis: "Distance le long de l’axe",
        distance_to_track_centre: "Distance au centre de la voie",
        distance_to_gnd_axis: "Distance à l’axe GND",
      },
      clip_reference_requires_axis_layer: "Une coupe le long d’un axe nécessite une couche d’axes SIG (GND) visible dans la vue 3D.",
      clip_reference_no_visible_axis: "Aucun axe sélectionnable n’est visible dans la vue 3D actuelle.",
      openLayers: {
        basePoint: "point de base",
        left: "GAUCHE",
        right: "DROITE",
        on_axis: "SUR L’AXE",
      },
      tb: {
        axis: "Mesures d’axe",
        kilometrierung_title: "Déterminer le kilométrage",
        kilometrierung_distance_title: "Mesurer sur l’axe kilométrique",
        gleisachse_distance_title: "Mesurer sur l’axe de voie",
        gleisachse_gap_title: "Distance à l’axe de voie",
        kilometrierung_help: "Sélectionnez d’abord l’une des lignes kilométriques chargées, puis terminez la mesure du kilométrage par un clic. Pour une autre mesure, sélectionnez de nouveau la ligne kilométrique.",
        kilometrierung_distance_help: "Sélectionnez d’abord l’une des lignes kilométriques chargées et choisissez un point de base. Commencez ensuite les mesures depuis le point de base en sélectionnant de nouveau la ligne kilométrique.",
        gleisachse_distance_help: "Sélectionnez d’abord l’un des axes de voie chargés et choisissez un point de base. Commencez ensuite les mesures depuis le point de base en sélectionnant de nouveau l’axe de voie.",
        gleisachse_gap_help: "Sélectionnez d’abord l’un des axes de voie chargés et calibrez l’écart par rapport à l’axe de voie. Sélectionnez ensuite de nouveau l’axe de voie et mesurez sur la base de l’écart calibré.",
        profile_along_axis_title: "Profil le long de l’axe",
        profile_perpendicular_title: "Profil perpendiculaire à l’axe",
        axis_measurement_value: "Mesure d’axe",
        axis_line_number: "Ligne",
        gleisachse_gap_2d_help: "Sélectionnez d’abord l’un des axes de voie chargés et calibrez l’écart : placez les rails guides verts sur les rails de l’orthophoto et cliquez. Chaque clic mesure ensuite la distance à l’axe de voie calibré.",
        gleisachse_gap_3d_help: "Sélectionnez d’abord l’un des axes de voie chargés. Chaque clic mesure ensuite la distance du point à l’axe de voie.",
      },
      max_active_geo_layers_short: "Max. {{count}}",
      dd: {
        pin_dropdown: "Épingler la fenêtre",
        show_info: "Informations",
        show_settings: "Paramètres",
        show_filter: "Options de filtre",
        search: "Recherche de ressources",
      },
    },
    lrp: {
      resumeSurvey: {
        title: "Souhaitez-vous continuer à modifier le dernier trajet?",
        openLastSurvey: "Ouvrir le dernier trajet",
        goToMap: "Vers la carte",
        error: "Le dernier relevé n'a pas pu être ouvert. Veuillez réessayer ou aller à la carte.",
      },
      baseMap: {
        selectedTrackPoint: "Point de suivi sélectionné"
      },
      filters: {
        filter: "Filtrer",
        filterByName: "Filtrer par nom",
        filtersByDFA: "Filtrer par ligne DfA",
        filterByKMRange: "Filtrer par écart kilométrique",
        minKm: "Kilométrage min.",
        maxKm: "Kilométrage max.",
      },
      menuBar: {
        object: 'Objets',
        minProfile: 'Profil minimum',
        trackGeo: 'Géométrie de la piste',
        search: 'Rechercher',
        searchFor: 'Rechercher...',
        results: 'Résultats',
        trajectories: 'Trajets',
        lrpoExport: 'LRPO-export',
        traversedGtgStrands: 'Lignes GTG',
        traversedDfaLines: 'Lignes DfA',
        kmAndDfaValue: 'Kilométrage et lignes DfA',
        swlObjects: 'Objets',
        gtgStrands: 'Brins GTG',
        jumpToObject: "Aller à l'objet",
        showPopUp: "Afficher Popup d'édition",
        showProfile: "Afficher le profil",
        visible: "Visible",
        nonVisible: "Non visible",
        trackAxis: "Axes de voie réels",
        railHeads: "Chapeau de rail",
        contactWires: "Caténaires",
        runsDdInfo: "Ce menu affiche toutes les trajets disponibles.",
        minProfileDdInfo: "Ce menu affiche tous les profils minimaux disponibles dans ce trajet.",
        trackGeoDdInfo: "Ce menu permet d'afficher toutes les géométries de voie dérivées du nuage de points.",
        swlDdInfo: "Ce menu affiche tous les objets et collisions disponibles dans cette inspection.",

      },
      mb: {
        loading: "Chargement...",
        prev_swl: "Objet précédent (Q)",
        next_swl: "Objet suivant (W)",
        show_popup: "Afficher la fenêtre d'information (I)",
        show_profile: "Afficher le profil (P)",
        create_swl: "Créer un nouvel objet (O)",
        deleteSelectedObjects: "Supprimer les objets sélectionnés",
        delete: "Supprimer",
        deleteSelectedObjectsConfirm: "Voulez-vous vraiment supprimer les objets sélectionnés ? Cette action est irréversible.",
        deleteSelectedObjectsCount: "Vous êtes sur le point de supprimer {{count}} objets.",
        deleteSelectedObjectsCannotUndo: "Cette action ne peut pas être annulée.",
        deleteConfirmation: "Je suis conscient que cette action est irréversible.",
        deleteSelectedObjectsWarning: "Vous ne pouvez pas supprimer plus de 1 000 objets à la fois. Veuillez répartir la suppression en plusieurs opérations."
      },
      status: {
        all: 'Tous',
        open: 'Ouvert',
        closed: 'Fermé',
        editing: 'Modification',
        exported: 'Exporté',
        discarded: 'Rejeté',
        filterByName: 'Filtrer par nom',
        status: 'Statut',
        completeProcessing: 'Traitement complet'
      },
      loadingTrajectories: 'Chargement des trajets...',
      loadingSwlObjects: "Chargement d'objets...",
      changeStatusDialog: 'Voulez-vous vraiment fermer cet objet ?',
      discardSwlObject: "Voulez-vous rejeter cet objet de manière irrévocable ?",
      open: "Ouvrir",
      trajectory: 'Trajet',
      processing: 'Traitement',
      popup: {
        attr: {
          type: "Type",
          coordinates: "Points",
          position: "Position",
          description: "N° d'objet",
          remark: "Remarque",
          siopB: "SIOP B",
          trackData: "Dév / Ray",
          measureDate: "Date",
          distanceNeighbor: "Voie ga / dr",
          createdManually: "Saisie",
          swlId: "ID de l'objet",
        },
        multipleGtgStrandsFound: 'Plusieurs brins GTG trouvés !',
        remove_coord: "Supprimer la coordonnée",
        add_coord: "Ajouter une nouvelle coordonnée",
        confirm_coords: "Confirmer les modifications des coordonnées",
        discard_changes: "Annuler les modifications",
        save_changes: "Enregistrer les modifications",
        close_popup: "Fermer la fenêtre",
        edit: "Modifier",
        manually: "Manuel",
        automatically: "Automatique",
        minPoints: 'Points min',
        maxPoints: 'Points max',
        pointsToAdd: 'Points trop peu',
        pointsToRemove: 'Points en trop',
        cancel: 'Annuler',
        export_pdf: 'Exporter en PDF',
        discard: "Rejeter l'objet",
      },
      swl: {
        flMast: "Pylône",
        miscMast: "Pylône individuel",
        noiseBarrier: "Paroi antibruit",
        p35: "P35",
        p55: "P55",
        auxiliaryP55: "Marche pied",
        miscPlatformEdge: "Autre bord de quai",
        dwarfLargeRight: "Nain grand visible",
        dwarfLargeWrong: "Nain grand invisible",
        dwarfSmallRight: "Nain petit visible",
        dwarfSmallWrong: "Nain petit invisible",
        dwarfEtcsRight: "Nain ETCS visible",
        dwarfEtcsWrong: "Nain ETCS invisible",
        overpassShort: "Passage supérieur court",
        overpassLong: "Passage supérieur longue",
        signalBasketOld: "Panier de signal ancien",
        prohibitionSign: "Interdiction de traverser",
        unknown: "Inconnu",
        misc: "Autre objet",
        tunnel: "Tunnel",
        abfahrbefehl: "Ordre de départ",
        abhang: "Pente",
        abspannung: "Hauban",
        absperrung: "Barrière latte",
        abstellsektorentafel: "Panneau de secteur de garage",
        absturzsicherung: "Protection anti-chute",
        ankuendigungslampe: "Signal annonce rond",
        aufhaengung: "Support de signal vertical",
        aufhaengungIndividuell: "Support individuel",
        barrierenStock: "Barrière PN-Support",
        beleuchtung: "Luminaire",
        betonaufsatzIndividuell: "Soupirail individuel",
        betondecke: "Couvercle béton",
        betonpfeilerIndividuell: "Pilier individuel",
        betontraeger: "Poutre en béton",
        boeschung: "Talus",
        brueckenpfeiler: "Pile de pont",
        brueckentraeger: "Pont métallique",
        buegel: "Echelle support",
        buegelsenklichtsignal: "Signal d’abaissement de pantographe",
        buegelsenksignal: "Plaque LC losange",
        buegelsenksignalBreit: "Plaque LC large",
        buegelsenksignalSchmal: "Plaque LC étroite",
        dach: "Toit",
        dachIndividuell: "Toit individuel",
        dachablauf: "Descente d'eau",
        dachrinne: "Chéneau",
        dachstuetze: "Support de toit",
        dienstweg: "Dégagement de service",
        dienstwegLf: "Caillebotis entretien",
        dreiecksaufsatz: "Plaque triangulaire",
        dreiecktafel: "Panneau triangulaire",
        eisenbruecke: "Pont métallique portique",
        elektrokasten: "Boîte électrique",
        erdungsstangenfach: "Casier perche mise à terre",
        etcsTafel: "ETCS Signal",
        fahrdraht: "Ligne de contact",
        fahrtstellungsmelder: "Voie libre",
        fia: "Téléaffichage",
        fundament: "Fondation",
        gelaender: "Barrière métallique",
        geschwSignal: "Indicateur de vitesse",
        gewichteFuerAbspannung: "Contrepoids",
        halade: "Rail repère",
        halterung: "Support",
        haltestellenTafel: "Panneau H rond",
        handrad: "Poignée robinet",
        handschalter: "Interrupteur LC",
        hektometertafel: "Panneau hectométrique",
        hemmschuhhalter: "Sabot d'arrêt",
        hydrant: "Borne hydrante",
        kabelkanal: "Caniveau",
        kabelschiene: "Canal",
        kabelverteiler: "KV",
        kamera: "Caméra",
        karrenuebergang: "Signal K",
        lautsprecher: "Haut-parleur",
        leiter: "Echelle",
        leiterbuegel: "Echelle de signal",
        leiterhalterung: "Support d'échelle",
        leitplanke: "Glissières de sécurité",
        lichtschranke: "Photocellule RB",
        mastFussplatte: "Plaque de mâts",
        mauer: "Mur",
        mauer120Plus: "Mur 120 Plus",
        mauerIndividuell: "Mur individuel",
        melder: "Interphone",
        nachbargleis: "Voie contigue",
        notausstieg: "Sortie de secours",
        notfallschieber: "Vanne d‘urgence",
        passarelle: "Passerelle",
        perronIndividuell: "Quai individuell",
        perrondach: "Marquise",
        pfosten: "Poteau",
        podest: "Podium",
        podestIndividuell: "Podium individuell",
        prellbock: "Heurtoir",
        railsafe: "Railsafe",
        rampe: "Quai de chargement",
        rampeIndividuell: "Quai de chargement ind",
        rampeSchraeg: "Rampe",
        rangierhaus: "Poste d'enclenchement",
        rangiersignal: "Signal de manœuvre",
        rohr: "Tube",
        schacht: "Chambre",
        schotterspriessung: "Etayage du ballast",
        schutzgeruest: "Barrage de protection",
        schutzgitter: "Grillage",
        schutzNische: "Niche de protection",
        schutztrennung: "séparation protectrice",
        sicherheitsbuegel: "Etrier de sécurité",
        siemens: "Boîte Siemens",
        signalAlt: "Signal vieux",
        signalIndividuell: "Signal individuel",
        signalNeu: "Signal nouveau",
        signalBedarfshalt: "Signal d'arrêt sur demande",
        signalkorbNeu: "Panier de signal nouveau",
        stahlstuetzenfussKonisch: "Pont métallique poutre",
        signaltafelRund: "Signal rond",
        standhoehe: "Niveau du terrain",
        stromanschluss: "Prise électrique",
        tafelGross: "Panneau grand",
        tafelKlein: "Panneau petit",
        thalesAlcatelKasten: "Boîte Thales/Alcatel",
        traeger: "Poutre",
        treppe: "Escalier",
        ueberfuehrungkurz: "Passage supérieur court",
        ueberwerfung: "Saut-de-mouton",
        uhr: "Horloge",
        unterfuehrung: "Passage sous-voie",
        verbotstafelTypC: "Interdiction de traverser type C",
        versicherungsbolzen: "Repère Laser",
        wasseranschluss: "Prise d'eau",
        weichenbild: "Lanterne d'aiguille en tôle",
        weichenlaterne: "Lanterne d'aiguille",
        weichenlichtsignal: "WLS-Signal lumineux d'aiguille",
        weichenstellbock: "Support Laterne d'aiguille",
        wetterstation: "Station météo",
        zaun: "Clôture",
        zeitwEinbau: "Empiètement temp",
        zugsvorheizung: "Préchauffage",
        zwergEtcsTafelFalsch: "Nain plaque ETCS invisible",
        zwergEtcsTafelRichtig: "Nain plaque ETCS visible",
        zwergMitDreieckaufsatz: "Nain triangle"
      },
      minProfile: {
        name: "Profil minimum",
        loadingMinProfiles: "Charger le profil minimum…",
        downloadDialogTitle: 'Êtes-vous sûr de vouloir télécharger le fichier ?',
        approve: "Télécharger",
      },
      singleProfile: {
        name: "Profil individuel"
      },
      profileInfo: {
        measurement: "Mesures",
        startMeasurement: "Démarrer la mesure (L)",
        stopMeasurement: "Arrêter la mesure",
        showProfile: "Afficher le profil (P)",
        createObject: "Créer un objet (O)",
        navigateForward: "Naviguer vers l'avant (.)",
        navigateBackward: "Naviguer vers l'arrière (,)",
        clearMeasurement: "Effacer la mesure",
        profileSize: "Épaisseur du profilé",
        placedCoordinate: "Coordonnée placée",
        legend: {
          legend: "Légende",
          export: "Exportation",
          infos: "Infos",
          roi: "Region Of Interest dont l'origine est l'axe de la voie parcourue.",
          schienenkoepfe: "Têtes de rail détectées sur la voie à laquelle l'objet se rapporte.",
          gleisachse: "Axe détecté de la voie à laquelle se rapporte l'objet. Référence pour la distance dx."
        }
      },
      pointCloudInfo: {
        appearance: "Apparence",
        opacity: "Opacité du NP",
        changeMode: "Changer de mode",
        panorama: "Panorama",
        trajectory: "Trajectoire",
        pointCloud: "Nuage de points",
        trajectoryMode: "Mode de trajectoire",
        panoramaMode: "Mode panoramique",
        toPanoramaMode: "Vers le mode panoramique",
        toTrajectoryMode: "Vers le mode de trajectoire",
        showReferencePoints: "Afficher les points de référence",
        showBbox: "Afficher Bounding Box",
        labels: "Étiquettes",
      },
      infoContainer: {
        mapRun: "MAP",
        mapOverview: "MAP",
        sceneRun: "3D",
        profileRun: "PRF",
        minimizeMap: "Réduire la carte",
        normalMap: "Carte normale",
        rotateLeft: "Gauche (X)",
        rotateRight: "Droite (Y)"
      }
    },
    dashboard: {
      yourProject: "Vos projets ({{count}})",
      overview: "Tableau de bord",
      noCustomerWarning: "Vous n'avez encore été affecté à aucun client. Veuillez contacter votre administrateur.",
      noLinkedCustomer: "Aucun client associé",
      noProjectWarning: "Aucun droit de projet attribué ! Veuillez contacter l'équipe projet !",
      search: "Recherche",
      projectCard: {
        processes: "Processus",
        showAll: "Afficher tout"
      },
      table: {
        search: "Recherche",
        projectTitle: "Titre du projet",
        processCount: "Nombre de processus",
        epsg: "EPSG",
        openInApp: "Ouvrir dans l'application"
      },
      pd: {
        selectionNeeded: "Veuillez d'abord sélectionner un projet",
        deleteModalContent: "Voulez-vous vraiment supprimer de manière irréversible le projet sélectionné et toutes les données/processus associés ?",
        update: "Actualiser",
        discard: "Annuler les modifications",
        selection: "Projet sélectionné",
        create: "Créer",
        details: "Information",
        administration: {
          title: "Administration",
          processesText: "Processus chargés",
          usersText: "Utilisateurs ajoutés"
        },
        pgnd: "{{- projectName}} GIS/GND",
        userAccess: "Autorisation de projet",
        createProject: "Créer un projet",
        projects: "Projets",
        projectSelection: "Sélection de projet",
        projectUAcess: "{{- projectName}} Autorisations de projet",
        projectProcess: "{{- projectName}} Liste des processus",
        projectProcessAccess: "{{- projectName}} Autorisations de processus",
        openProject: "Ouvrir",
        newProject: "Créer un projet",
        uploadProjectImage: "Télécharger l'image du projet",
        projectCreateMessage: "Projet créé",
        projectName: "Nom du projet",
        logoUploaded: "Logo du projet téléchargé",
        logoLoaded: "Logo chargé",
        customerName: "Nom du client",
        projCode: "Code du projet",
        projDuration: "Durée du projet",
        years: "Années",
        desc: "Description du projet",
        coord: "Système de coordonnées",
        accountAllocation: "Objectif de comptabilisation",
        fromCreditBalance: "à partir du solde de crédit",
        plannedCredit: "Crédit(s) prévu(s)",
        dataOwner: "Propriétaire des données",
        mmSize: "Taille Mobile Mapping",
        pcSize: "Taille Point Clouds",
        heliSize: "Taille Hélicoptère",
        flightArea: "Zone de vol",
        gigaPixel: "GigaPixel",
        save: "Enregistrer",
        delete: "Supprimer",
        dragFile: "Faire glisser le fichier ici",
        fileExplorer: "Ouvrir la barre de menu des fichiers",
        userRemoved: "Utilisateur retiré",
        userAdded: "Utilisateur ajouté",
        addUser: "Ajouter un utilisateur",
        addAccount: "Ajouter un compte",
        users: "Utilisateurs",
        roles: "Rôles",
        add: "Ajouter",
        cancel: "Annuler",
        name: "Nom",
        remove: "Supprimer",
        export: "Exporter",
        action: "Action",
        removeWarning: "Êtes-vous sûr de vouloir supprimer l'enregistrement?",
        projectCreate: "Créer un projet",
        projectDelete: "Supprimer le projet",
        projectUpdate: "aktualiser",
        gnd: "GIS/GND",
        layers: "Couches",
        layerType: "Type de couche",
        editLayer: "Modifier {{name}}",
        tracktopography: "Topographie des voies SBB",
        trackdataDbigo: "Données du réseau de voies DB IGO",
        kilometerLineSegment: "Tronçons (kilométrage)",
        trackEdgeSegment: "Bords de voie (positionnement)",
        requiredEPSGDbigo: "EPSG requis : 4326",
        addNewLayer: "Ajouter une nouvelle couche",
        layerName: "Nom de la couche",
        unnamedLayer: "Couche sans nom",
        layerColor: "Couleur de la couche",
        layerDimensions: "Dimensions de la couche",
        invalidHexString: "Chaîne hexadécimale invalide",
        uploadError: "Erreur inattendue. Veuillez réessayer plus tard ou nous contacter si le problème persiste.",
        layerDeleteMsg: "Êtes-vous sûr de vouloir supprimer la couche et tous les objets associés ?",
        edit: "Modifier",
        noUploadsYet: "Il semble que cette couche n'ait pas encore de téléchargements. Soyez le premier à en ajouter un avec le bouton rouge.",
        createNewUpload: "Télécharger de nouvelles données",
        deleteUpload: "Voulez-vous supprimer les données téléchargées du {{date}} et tous les objets associés ?",
        deleteUploadTitle: "Données GIS/GND téléchargées '{{ uploadToDelete }}'",
        newUpload: "Nouvelles données GIS/GND",
        correspondingUploadedData: "Données GIS/GND",
        forLayer: "pour la couche ",
        targetType: "Type de cible",
        objectExport: "LRPO Exportation",
        Gleispunkte: "Points de voie",
        tunnels: "Tunnel",
        kilometerLine: "Kilométrage de ligne",
        kilometerOrientation: "Orientation de ligne",
        tracks: "Noms de tronçons GTG",
        tracktopographyInfo: "Veuillez noter l'attribution correcte des fichiers CSV. Ceci est très important. Si l'attribution n'est pas correcte, aucune donnée ne peut être créée. Exemple : noms des tronçons GTG (gtg_strang_neid.csv), points de voie (gleispunkte.csv), tunnels (tunnel.csv), kilométrage des lignes (linien_kilometrierung.csv), orientation des lignes (linien_orientierung.csv).",
        selectFile: "Sélectionner un fichier",
        supportedGeometryTypes: "Types de géométrie pris en charge : ",
        jsonNoFeatures: "GeoJSON doit contenir au moins une entité.",
        jsonMultipleTypes: "GeoJSON contient plusieurs types de géométrie. Seules les collections avec un type sont autorisées jusqu'à présent.",
        jsonUnsupportedType: `Type de géométrie non pris en charge {{unsupportedType}} dans GeoJSON. Utilisez soit Point soit MultiLineString.`,
        gndAddTitle: "Ajouter de nouveaux éléments",
        gndError: "La couche n'a pas pu être enregistrée. Veuillez réessayer plus tard.",
        gndSuccess: "Couche enregistrée avec succès. Vous pouvez maintenant l'afficher manuellement dans le visualiseur.",
        gndSubmit: "Ajouter",
        selectJson: "Sélectionner GeoJSON",
        deleteRoles: "Êtes-vous sûr de vouloir retirer cet utilisateur du client ?",
        editAccount: "Modifier les rôles",
        inviteUser: "Utilisateur introuvable",
        inviteOrProvisionUserMessage: "L'utilisateur {{email}} n'existe pas sur la plateforme. Vous avez deux options : vous pouvez provisionner l'utilisateur temporairement jusqu'à sa première connexion avec un fournisseur d'identité connu, ou lui envoyer une invitation pour s'enregistrer auprès du fournisseur d'identité x2bim.com.",
        provisionUserMessage: "L'utilisateur {{email}} n'existe pas sur la plateforme. Vous pouvez provisionner l'utilisateur temporairement jusqu'à sa première connexion avec son fournisseur d'identité.",
        sendInvitation: "Envoyer l'invitation",
        provisionUser: "Provisionner l'utilisateur",
      },
      processes: {
        selection: "Sélection",
        processes: "Liste des processus",
        userAccess: "Autorisations de processus",
        procArchived: "Processus supprimé",
        procDeleted: "Suppression du processus déclenchée ! Cela peut prendre un certain temps avant que ce processus ne soit terminé.",
        procArchivedFailed: "Échec de la suppression du processus",
        pID: "ID",
        pTitle: "Titre",
        pDesc: "Description",
        pType: "Type",
        pStatus: "Statut",
        all: "Tous",
        pSourceDate: "Date source",
        pInitDate: "Date du processus",
        pTags: "Tags",
        actions: "Actions",
        internal: "Interne",
        external: "Externe",
        standUser: "Utilisateur standard",
        usedStorageMB: "Espace utilisé",
        creditsConsumed: "Crédits consommés",
        usedStorageShort: "Stockage",
        creditsConsumedShort: "Crédits",
        archive: "Archiver",
        close: "Fermer",
        addTagToProcess: "+ Ajouter un tag au processus",
        selectOrCreateTag: "Sélectionner ou créer un tag",
        deleteProcessMsg: "Voulez-vous vraiment supprimer ce processus ?",
        areYouSure: "Êtes-vous sûr ?",
        confirmText: "Voulez-vous vraiment {{count}} processus pour l'utilisateur standard {{status}} ?",
        activate: "Activer les sélectionnés",
        deactivate: "Désactiver les sélectionnés",
        copyId: "Copy ID",
        idCopied: "Id Copied"
      },
      objectExport: {
        warning: "Problèmes pour obtenir des informations sur les trajets",
        confirm: "Veuillez confirmer",
        confirm_text: `Si vous confirmez cette exportation, {{count}} objet(s) sera/seront exporté(s)`,
        export: "Export",
        heading: "Exportation d'objets vers LIRA",
        text: 'Sélectionnez des trajets individuels pour exporter des objets vers LIRA. Les objets exportables sont ceux qui ont le statut « fermé ». Seuls les trajets contenant au moins un objet fermé sont affichés.',
        p_disc: "Description",
        date: "Date",
        open: "ouvert",
        closed: "fermé",
        exported: "exporté",
        noItem: "Pour l'instant, il n'y a pas encore d'objets à exporter.",
        exportButton: `Export {{count}} trajet(s)`,
        exportSuccessMessage: `L'exportation de(s) {{count}} objet(s) a commencé. Cela prendra quelques minutes. Si l'exportation a réussi, tous les objets sont dans l'état « exporté ».\``,
        loading: "Chargement des trajets exportables...",
      }
    },
    uploadModal: {
      dropFileHere: "Déposer le fichier ici",
      clickOrDrop: "Cliquez ou déposez pour sélectionner",
      selectFile: "Sélectionner un fichier",
      parsingFailed: "Échec de l'analyse du fichier",
      acceptedFileTypes: "Formats de fichier pris en charge : ",
    },

    notify: {
      roleSuccess: "Rôles enregistrés",
      invitationSent: "Invitation envoyée avec succès",
      invitationFailed: "Échec de l'envoi de l'invitation",
      provisionFailed: "Échec du provisionnement de l'utilisateur",
      addUserFailed: "Échec de l'ajout de l'utilisateur",
      maxUsersReached: "Le nombre maximum d'utilisateurs pour ce client a été atteint",
      userAddedToCustomer: "Utilisateur ajoute au client",
      rolesFailed: "Erreur lors de l'enregistrement des rôles",
      userAlreadyInCustomer: "Cet utilisateur appartient déjà au client. Pour attribuer des rôles supplémentaires, utilisez l'action de modification dans le tableau des utilisateurs.",
      noActiveProject: "Aucun projet actif",
      confirm: "Veuillez confirmer",
      confirmDeleteProjectMessage: "Voulez-vous vraiment supprimer ce projet ?",
      confirmAction: "Oui",
      cancel: "Non",
    },

    messages: {
      loginErrorTittle: "Session expirée !",
      loginError: "Votre session a été terminée en raison d'une inactivité. Veuillez vous reconnecter !",
      login: "Connexion",
      logOut: "Déconnexion",
      pricingButton: "Tarification",
      x2bimToInfraviewButton: "X2BIM sur Infraview",
      requestADemoButton: "Demander une démo",
      agbsButton: 'ALB',
      notAllowed: "Accès refusé",
      notAllowedMessage: "Vous n'avez été affecté à aucun projet ou vous n'avez pas les autorisations appropriées. Veuillez informer votre contact projet pour procéder à la déverrouillage si nécessaire.",
      goBack: "Retour",
      apiError: "La connexion au serveur a échoué. Veuillez réessayer",
      tryAgain: "Reconnecter",
      apiIssue: "La demande a échoué avec le statut {{statusCode}}.",
      errorTittle: "Une erreur s'est produite :( !",
      progressSaved: "Progrès enregistré",
      noActiveProject: "Aucun projet actif !",
      onlyPNG: "Seules les fichiers PNG sont autorisés, veuillez vous assurer que le bon format de fichier est utilisé !",

    },
    pricing: {
      mainTitle: 'Tarification X2BIM',
      included: 'Inclus',
      additionalUser: 'Utilisateur Supplémentaire',
      includedCredits: 'Crédits Inclus',
      creditCost: 'Coût du crédit',
      inclProcessAndHosting: '(Incl. Traitement et Hébergement)',
      concurrProcessPipelines: 'Pipelines de Traitement Simultané',
      tierButton: 'Commencer',
      tier: 'Étage',
      credits: 'Crédits',
      'Order Access': 'Accès aux commandes',
      'Tools': 'Outils',
      'Updates': 'Mises à jour',
      'Support': 'Support',
      'Unlimited Projects': 'Projets illimités',
      'SSO': 'Authentification unique',
      'Unlimited Users*': 'Utilisateurs illimités*',
      table: {
        title: 'Tableau X2BIM',
        header: ['Position', 'Description', 'Unité', 'Crédits par unité'],
        content: [
          { position: '1', description: 'Données UAV/Survol', unit: '1 GigaPixel (Gpix)', creditsPerUnit: '1000' },
          { position: '2', description: 'Nuages de points (y compris les images panoramiques)', unit: '1 Gigaoctet (GB)', creditsPerUnit: '200' },
          { position: '3', description: 'Coûts de stockage généraux (par mois)*', unit: '1 Gigaoctet (GB)', creditsPerUnit: '5' },
          { position: '4', description: 'IA/Reconnaissance d’objets *', unit: '-', creditsPerUnit: '-' },
          { position: '5', description: 'Importation de plans (Geotiff)', unit: 'par processus', creditsPerUnit: '250' },
          { position: '6', description: 'Modèle IFC', unit: 'par processus', creditsPerUnit: '250' },
          { position: '7', description: 'Configuration de l’installation SSO**', unit: 'unique', creditsPerUnit: '5000' },
        ]
      },
      calculator: {
        title: 'Aide au calcul',
        subTitle: 'Calculez combien de crédits supplémentaires par mois vous avez besoin.',
        selectATier: 'Sélectionnez un niveau :',
        tiers: ['De base', 'Avancé', 'Entreprise'],
        noFlightsPerMonth: 'Nombre de vols / mois',
        noPhotosPerFlight: 'Nombre de photos / vol',
        megapixels: 'Mégapixels',
        creditsIncluded: 'Crédits inclus dans le niveau {{tier}}',
        creditsPerMonth: 'crédits/mois',
        extraCreditsPerMonth: 'Crédits supplémentaires nécessaires par mois:',
        imageProcessing: {
          title: 'Calculez les crédits mensuels supplémentaires nécessaires pour vos besoins en traitement d’images.',
        },
        pointCloudProcessing: {
          title: 'Calculez les crédits mensuels supplémentaires nécessaires pour vos besoins en traitement de nuages de points.',
        }
      }
    },
    credit: {
      titleCustomer: "{{customer}}",
      titleCredits: "Bilan des crédits : {{credit}}",
      noActiveCustomer: "Client inactif! Veuillez sélectionner un client dans le menu latéral.",
      noTxns: "Aucune transaction effectuée",
      consumptionDetails: "Détails sur la consommation par projet",
      noProjectWiseConsumption: "Aucun crédit utilisé",
      creditTxns: "Transactions de crédit",
      creditTxnsAll: "Transactions de crédit de tous les clients",
      balanceCustomers: "Solde de crédit par client",
      txnDate: "Date de transaction",
      creditIncome: "Crédits entrants",
      creditConsumed: "Crédits consommés",
      txnStatus: "Statut",
      txnDescription: "Description",
      addedBy: "Ajouté par",
      open: "Ouvert",
      close: "Fermé",
      project: "Projet",
      consumedBy: "Consommé par",
      sum: "Total",
      year: "Année",
      "January": "Janvier",
      'February': "Février",
      'March': "Mars",
      'April': "Avril",
      'May': "Mai",
      'June': "Juin",
      'July': "Juillet",
      'August': "Août",
      'September': "Septembre",
      'October': "Octobre",
      'November': "Novembre",
      "December": "Décembre",
      customerBalance: "Solde du client",
      consumptionPerCustomer: "Consommation par client",
      addTxn: "Ajouter une transaction",
      customer: "Client",
      addTxnButton: "Ajouter une transaction",
      add: "Ajouter",
      change: "Modifier",
      customerId: "ID client",
      txnType: "Type de transaction",
      amount: "Montant",
      desc: "Description",
      negativeTxn: "Transactions négatives",
      positiveTxn: "Transactions positives",
      balance: "Solde",
      CreditAdded: "Crédits ajoutés",
      CreditRemoved: "Crédits retirés",
      credits: "Crédit(s)",
      dateRange: "Plage de dates",
      startDate: "Date de début",
      endDate: "Date de fin",
      apply: "Appliquer",
      trendcreditconsumption: "Tendance de la consommation de crédits",
      trendView: "Tendance",
      monthlyStackView: "Cumul mensuel",
      dailyStackView: "Cumul quotidien",
      topCustomersView: "Meilleurs clients",
      creditConsumption: "Consommation de crédits",
      creditBalance: "Solde des crédits",
      filters: "Filtres",
      allOption: "Tous",
      selectedCount: "{{count}} sélectionné(s)",
      clearSelection: "Effacer la sélection",
      dateFrom: "Du",
      dateTo: "Au",
      creditConsumptionTrend: "Tendance de consommation de crédits",
      accumulated: "Accumulé",
      aggregated: "Agrégé",
      groupBy: "Grouper par",
      groupByStatus: "Statut (Ouvert/Fermé)",
      timeWindow: "Fenêtre temporelle",
      noDataAvailable: "Aucune donnée disponible pour les filtres sélectionnés.",
      exportCsv: "Exporter CSV",
      collapseGroup: "Réduire le groupe",
      expandGroup: "Développer le groupe",
      ivProjectId: "ID projet iV",
      projectCode: "Code du projet",
      accountAllocation: "Allocation de compte",
      date: "Date",
      transactionType: "Type de transaction",
      processPID: "Processus (PID)",
      processTitle: "Titre du processus",
      runningBalance: "Solde en cours",
      errorLoading: "Erreur de chargement : {{message}}",
      infrastructure: "Infrastructure",
      transactionsCount_one: "{{count}} transaction",
      transactionsCount_other: "{{count}} transactions",
    },

    // BIM Viewer. The rest of this section is not translated into French yet, so it falls back
    // through i18n.js's chain (de → en); these are the keys that have been done.
    bim: {
      tools: {
        cameraFrustums: "Stations de prise de vue",
        cameraFrustumsFocus: "Zoomer sur toutes les caméras",
        cameraFrustumImages: "Afficher les photos sur les plans de caméra",
        cameraFrustumCount: "{{count}} caméras",
        cameraFrustumLoading: "Chargement des caméras…",
        cameraFrustumNone: "Aucun vol avec photos chargé",
        cameraFrustumFlights: "Vols",
        photoLookupPick: "Rechercher les photos d'un point — cliquez dans la scène",
        photoLookupCount: "{{count}} photos montrent ce point",
        photoLookupEmpty: "Aucune photo ne montre ce point",
        photoLookupHint: "Choisissez un point dans la scène pour voir quelles photos le montrent.",
        photoLookupClose: "Fermer",
        cameraViewTitle: "Dans la photo · {{name}}",
        cameraViewHint: "Faites glisser pour regarder autour. Vous éloigner quitte cette vue.",
        cameraViewOpacity: "Opacité de la photo",
        cameraViewExit: "Quitter",
        cameraViewPrevious: "Photo précédente",
        cameraViewNext: "Photo suivante",
        panoramaViewTitle: "360° · {{name}}",
        panoramaViewHint: "Faites glisser pour regarder autour. Cliquez sur le sol pour passer à un panorama proche.",
        panoramaViewExit: "Quitter",
        panoramaViewPrevious: "Panorama précédent",
        panoramaViewNext: "Panorama suivant",
        panoramaViewOpacity: "Opacité du nuage de points",
        panoramaViewColorAdjustments: "Réglages de l'image",
        clipScene: "Découper la scène",
        clipDimensions: "Dimensions",
        clipRotation: "Rotation",
        clipInvert: "Inverser la découpe",
        clipGhostPersistent: "Toujours afficher le contexte découpé",
        clipSlice: "Mode coupe",
        clipSliceAxis: "Axe",
        clipPosition: "Position",
        clipThickness: "Épaisseur",
        clipPin: "Épingler le panneau",
        clipUnpin: "Détacher le panneau",
        clipFollowCamera: "La caméra suit la coupe",
        clipHandles: "Poignées de faces et de rotation",
        clipViewAlong: "Vue le long de {{axis}}",
        clipCloseProfile: "Fermer le profil altimétrique",
        clipOpenProfile: "Ouvrir le profil altimétrique",
        clipOpenProfileUnavailable: "Les profils altimétriques nécessitent une coupe X ou Y verticale et non inversée",
        profileWidth: "Largeur du profil",
        profileOpenSlice: "Afficher comme coupe 3D",
        profileOpenSliceUnavailable: "Les coupes 3D nécessitent une scène chargée",
        clipLinePicking: "Cliquez sur un axe dans la scène 3D … Échap ou un nouveau clic annule",
        clipLineSelect: "Coupe le long d’un axe – cliquez puis sélectionnez l’axe dans la scène 3D",
        clipLineReady: "Démarrer la coupe le long de l’axe {{label}}",
        clipLineActive: "Coupe le long de l’axe {{label}} – cliquez pour choisir un autre axe",
        clipLineWidth: "Largeur",
        clipFitView: "Ajuster la boîte à la vue actuelle",
        clipFitModel: "Ajuster la boîte au modèle entier",
        clipNudgeHint: "Pas de {{step}}.\nAvec Maj {{fine}}, avec Alt {{coarse}}.\nMaintenez la flèche pour répéter, de plus en plus vite.\nOu cliquez sur le nombre pour saisir une valeur exacte.",
        clipPrecisionHint: "Faites glisser un curseur pour les changements grossiers.\nMaj + glisser — fin, 1 m par pixel.\nAlt + glisser — très grossier.\nLes flèches avancent d'un cran ; Maj ▸ 1 m, Alt ▸ dix crans.\nCliquez sur un nombre pour saisir une valeur exacte.\nDans la scène : faites glisser un coin pour redimensionner, Maj pour déplacer la boîte, Alt pour un glissement fin."
      }
    }
  },
}